var map = {
	"./subdir/tmpl": 12,
	"./subdir/tmpl.js": 12,
	"./templateLoader": 9,
	"./templateLoader.js": 9,
	"./templateLoaderIndirect": 8,
	"./templateLoaderIndirect.js": 8,
	"./tmpl": 10,
	"./tmpl.js": 10
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.id = 1;
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;



/*****************
 ** WEBPACK FOOTER
 ** ./parsing/context/templates ^\.\/.*$
 ** module id = 1
 ** module chunks = 0
 **/